<template>
  <div class="container">
    <h3>Profile</h3>
    <!-- 基本信息修改 -->
    <div class="row pb-3">
      <!-- 邮箱输入 -->
      <div class="col-md-3">
        <fg-input
            class="no-border input-lg"
            addon-left-icon="now-ui-icons ui-1_email-85"
            placeholder="Email..."
            label="Email"
            v-model="user.email"
            disabled
        >
        </fg-input>
      </div>
      <!-- 组织输入 -->
      <div class="col-md-3">
        <fg-input
            class="no-border input-lg"
            addon-left-icon="now-ui-icons business_bank"
            placeholder="University/Organization..."
            label="University/Organization"
            v-model="user.uni_org"
            disabled
        >
        </fg-input>
      </div>
      <!-- 队伍名称输入 -->
      <div class="col-md-3">
        <fg-input
            class="no-border input-lg"
            addon-left-icon="now-ui-icons users_circle-08"
            placeholder="Team Name..."
            label="Team Name"
            v-model="user.team_name"
            disabled
        >
        </fg-input>
      </div>
      <!-- 保存修改按钮 -->
      <div class="col-md-3">
        <n-button type="primary" size="sm" round style="margin-top: 35px;" @click="saveChanges" disabled>Save Changes</n-button>
      </div>
    </div>

    <!-- 上传文件 -->
    <h3>Upload Results</h3>
    <div class="row pb-3">
      <div class="col-md-12 ml-auto mr-auto">
        <tabs slot="raw-content" tab-content-classes="tab-content-padding">
          <tab-pane v-for="(task, i) in $store.state.tasks" :key="i">
            <template slot="label">Task {{ i + 1 }}</template>
            <p class="category text-center">{{ task }}</p>
            <div class="mb-5">
              <!-- 测试阶段1界面 -->
              <div v-if="isLoaded">
                <h5>Phase 1: Upload labels for <span class="text-warning">test set 1</span> (Closed)</h5>
                <div>
                  <!-- 上传文件 -->
<!--                  <div>-->
<!--                    <el-upload class="upload-demo" action="#" :auto-upload="false" ref="upload1"-->
<!--                               :multiple="false" :on-change="methodsAll[i]" :file-list="fileList[i]"-->
<!--                               :disabled="summary[i].upload_times==maxUploadTimes">-->
<!--                      <n-button size="sm" type="primary" round class="mt-0"-->
<!--                                :disabled="summary[i].upload_times==maxUploadTimes">-->
<!--                        <i class="now-ui-icons arrows-1_cloud-upload-94"></i>-->
<!--                        Choose File-->
<!--                      </n-button>-->
<!--                      <div slot="tip" class="el-upload__tip">Remaining <span-->
<!--                          class="text-warning">{{ maxUploadTimes - summary[i].upload_times }}</span> uploads for today-->
<!--                      </div>-->
<!--                    </el-upload>-->
<!--                  </div>-->
                  <!-- 展示结果 -->
                  <div class="row">
                    <div class="col-md-6" v-if="summary[i].upload_all>0">
                      <h6 class="mt-3">Best Score in history</h6>
                      <div>Metrics: <span><strong>{{ summary[i].metrics.toFixed(3) }}</strong></span></div>
                      <div>Metrics respectively:
                        <div v-for="(metrics, metric_name) in summary[i].metrics_all" :key="metric_name">{{
                            metric_name
                          }}:
                          {{ metrics.toFixed(3) }}
                        </div>
                      </div>
                      <div>Upload Time: <span class="text-success">{{ summary[i].upload_date }}</span></div>
                    </div>
                    <div class="col-md-6" v-if="isUploaded[i]">
                      <h6 class="mt-3">Current Score</h6>
                      <div>Metrics: <span><strong>{{ current[i].metrics.toFixed(3) }}</strong></span></div>
                      <div>Metrics respectively:
                        <div v-for="(metrics, metric_name) in current[i].metrics_all" :key="metric_name">{{
                            metric_name
                          }}:
                          {{ metrics.toFixed(3) }}
                        </div>
                      </div>
                      <div>Upload Time: <span class="text-success">{{ current[i].upload_date }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 等候加载页面 -->
              <div class="text-center" v-else>
                <div>
                  <i class="now-ui-icons animate loader_gear spin" aria-hidden="true"></i>
                </div>
                <p>Loading sumbmission records...</p>
              </div>
            </div>
            <!-- 测试阶段2界面 -->
            <div>
              <h5>Phase 2: Upload executable code and checkpoint for <span class="text-warning">test set 2</span> (Closed)</h5>
              <!-- 展示结果 -->
              <div>
                <div v-if="isLoaded2">
                  <div class="mb-3">
                    <p v-if="summary2[i].allow_phase2">
                      Congratulations! Your team has passed the phase 1 testing for task {{ i + 1 }}. Please upload your
                      trained model
                      following the instructions below.
                    </p>
                    <p v-else>
                      Unfortunately, your team hasn't passed the phase 1 testing for task {{ i + 1 }}.
                    </p>
                  </div>
                  <!-- 上传文件 -->
<!--                  <div v-if="summary2[i].allow_phase2">-->
<!--                    <el-upload class="upload-demo" action="#" ref="upload2" :file-list="fileList2[i]"-->
<!--                               :multiple="false" :auto-upload="false" accept=".zip"-->
<!--                               :disabled="(!summary2[i].allow_upload) || (summary2[i].upload_times==maxUploadTimes2) || (!summary2[i].allow_disk)"-->
<!--                               :on-change="methodsAllPhase2[i]"-->
<!--                               :show-file-list="false">-->
<!--                      <n-button size="sm" type="primary" round class="mt-0">-->
<!--                        <i class="now-ui-icons arrows-1_cloud-upload-94"></i>-->
<!--                        Choose File-->
<!--                      </n-button>-->
<!--                      <div slot="tip" class="el-upload__tip" v-if="!summary2[i].allow_disk">Remaining <span-->
<!--                          class="text-warning">{{ summary2[i].free_disk.toFixed(1) }} GB </span> buffer memory, please-->
<!--                        wait for cleaning...-->
<!--                      </div>-->
<!--                      <div slot="tip" class="el-upload__tip mb-3">Remaining <span-->
<!--                          class="text-warning">{{ maxUploadTimes2 - summary2[i].upload_times }}</span> uploads in total-->
<!--                      </div>-->
<!--                    </el-upload>-->
<!--                    &lt;!&ndash; 进度条 &ndash;&gt;-->
<!--                    <div class="text-center" v-if="isUploading2[i]">-->
<!--                      <el-progress :text-inside="true" :stroke-width="24" :percentage="uploadPercentPhase2"-->
<!--                                   :status="uploadStatusPhase2"></el-progress>-->
<!--                      <div class="mt-2">-->
<!--                        <i class="now-ui-icons animate loader_gear spin" aria-hidden="true"></i>-->
<!--                        Please keep the window until uploading process finished.-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; 上传失败提示 &ndash;&gt;-->
<!--                    <div v-if="isShowError" class="text-center">-->
<!--                      <p>Fail to upload the model, please refresh the page and try again.</p>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="row" v-if="summary2[i].result.length>0">
                    <div class="col-md-4" v-for="(result2, j) in summary2[i].result" :key="j">
                      <h6>{{ $store.state.order[j] }} upload</h6>
                      <div>Filename: <span>{{ result2.filename }}</span></div>
                      <div>Upload Time: <span class="text-success">{{ result2.upload_date }}</span></div>
                      <div>
                        Transmit Time:
                        <span class="text-success" v-if="result2.transmit_date">{{ result2.transmit_date }}</span>
                        <span class="text-warning" v-else>processing...</span>
                      </div>
                      <div>
                        Implement Time:
                        <span class="text-success" v-if="result2.implement_date">{{ result2.implement_date }}</span>
                        <span class="text-warning" v-else>processing...</span>
                      </div>
                      <div v-if="result2.status=='Implemented'">
                        <div>Metrics: <span><strong>{{ result2.metrics.toFixed(3) }}</strong></span></div>
                        <div>Metrics respectively:
                          <div v-for="(metrics, metric_name) in result2.metrics_all" :key="metric_name">{{
                              metric_name
                            }}:
                            {{ metrics.toFixed(3) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="isUploaded[i]">
                      <h6 class="mt-3">Current Score</h6>
                      <div>Metrics: <span><strong>{{ current[i].metrics.toFixed(3) }}</strong></span></div>
                      <div>Metrics respectively:
                        <div v-for="(metrics, metric_name) in current[i].metrics_all" :key="metric_name">{{
                            metric_name
                          }}:
                          {{ metrics.toFixed(3) }}
                        </div>
                      </div>
                      <div>Upload Time: <span class="text-success">{{ current[i].upload_date }}</span></div>
                    </div>
                  </div>
                </div>
                <!-- 等候加载页面 -->
                <div class="text-center" v-else>
                  <div>
                    <i class="now-ui-icons animate loader_gear spin" aria-hidden="true"></i>
                  </div>
                  <p>Loading sumbmission records...</p>
                </div>
              </div>
            </div>


          </tab-pane>
        </tabs>
      </div>
    </div>
    <!-- phase2 历史上传修改记录 -->
    <div v-if="isLoaded3 && feedbacks.length>0" class="mb-5">
      <h3>Feedbacks for Phase 2 Testing</h3>
      <div v-for="(feedback, i) in feedbacks" :key="i" class="mb-2">
        <div>
          {{ feedback.date }} <span class="font-weight-bold">|</span> {{ $store.state.tasks[feedback.task] }}
          <span class="font-weight-bold">|</span>  {{ feedback.feedback }}
        </div>
      </div>
    </div>


    <!-- phase2 指导 -->
    <h3>Instructions for Phase 2 Testing</h3>
    <div class="pb-3">
      <h5>Testing Procedures</h5>
      <p>1. <span class="font-weight-normal">Upload</span>: Participants upload the trained model to our website</p>
      <div class="notice">* Notice: Participants who surpass the baseline are able to upload the trained model and can
        only upload the
        next model after the current one is implemented. The maximum times of successful implementation for each task
        are <span class="font-weight-normal">3</span>.
      </div>
      <p>2. <span class="font-weight-normal">Transmit</span>: Organizers will transmit the package file into the GPU
        machine.</p>
      <p>3. <span class="font-weight-normal">Implement</span>: Organizers will unzip the package file and implement the
        code to generate predicted results and compute the metrics.</p>

      <h5>File Preparation</h5>
      <p>Participants should create a folder containing the following files:</p>
      <p>1. The <span class="text-warning font-weight-normal">test data file</span> for phase 2 which is provided in the
        dataset.</p>
      <div class="notice">* Notice: Organizers will check whether the file is the same as the original one. Please keep
        the data file unchanged.
      </div>
      <p>2. The <span class="text-warning font-weight-normal">checkpoint file</span> that saves the trained model.</p>
      <p>3. The <span class="text-warning font-weight-normal">main program file</span> named <span
          class="text-warning font-weight-normal">main.py</span> that loads the trained model and produces the predicted
        results.</p>
      <div class="notice">* Notice: Participants should make sure by running the command <span
          class="font-weight-normal">`python main.py`</span> in the top-level directory, the result file named
        <span class="font-weight-normal">test_result.json</span>/<span class="font-weight-normal">test_result.txt</span>
        similar for
        phase 1 should be generated.
      </div>

      <h5>Dependencies</h5>
      <p>Organizers will implement the code with <span class="font-weight-normal">RTX 3090</span> (24GB Memory)</p>
      <p>Code implemented by <span class="font-weight-normal">python</span> is accepted and the current python version
        is <span class="font-weight-normal">3.8.8</span> with <span class="font-weight-normal">gcc</span> of <span
            class="font-weight-normal">7.3.0.</span></p>
      <div class="notice">* Notice: Programs realized by other coding languages are allowed but participants should also
        use `main.py` to start the program.
      </div>
      <p>Existing python packages are listed <a href="/resource_social22/data/requirements.txt" target="_blank">here</a>.
        If the package you need is missing or conflicting, please contact
        the organizers.</p>
    </div>


    <h3>Resources</h3>
    <div class="pb-3">
      <p>The large-scale weibo corpus for pre-training is available via <a
          href="https://pan.baidu.com/s/1xRhZwFpph3UYu3L1wn2xtQ" target="_blank"> Baidu Cloud Disk</a>. The extraction
        code is <span class="text-primary">shhk</span>.</p>
    </div>

    <h3>Contact</h3>
    <div class="pb-3">
      <p>Please scan the wechat QR code and join our wechat group to follow recent notifications and resolve
        problems.</p>
      <p>After joining the group, please modify your screen name as "[Name]-[Organization]".</p>
      <img width="120" src="/resource_social22/img/wechat_code_20220311.jpg" alt="">
    </div>

  </div>
</template>

<script>
import {Card, Tabs, TabPane, Button, FormGroupInput} from '@/components';
import {Checkbox} from "@/components";
import Vue from "vue";

export default {
  name: "indexConsole",
  components: {
    // Card,
    Tabs,
    TabPane,
    // MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      maxUploadTimes: 10,
      maxUploadTimes2: 3,
      isLoaded: false,
      isLoaded2: false,
      isLoaded3: false,
      feedbacks: [],
      isShowError: false,
      isUploaded: {0: false, 1: false, 2: false, 3: false, 4: false},
      user: {email: '', uni_org: '', team_name: ''},
      fileList: {0: [], 1: [], 2: [], 3: [], 4: []},
      fileList2: {0: [], 1: [], 2: [], 3: [], 4: []},
      uploadAll: 1,
      summary: {},
      summary2: {},
      bestMetrics: {},
      current: {},
      methodsAll: [this.uploadFile0, this.uploadFile1, this.uploadFile2, this.uploadFile3, this.uploadFile4],
      methodsAllPhase2: [this.uploadFile02, this.uploadFile12, this.uploadFile22, this.uploadFile32, this.uploadFile42],
      file: {},

      isUploaded2: {0: false, 1: false, 2: false, 3: false, 4: false},
      isUploading2: {0: false, 1: false, 2: false, 3: false, 4: false},
      isShowProgress: false,
      //是否显示进度条
      uploadPercentPhase2: 0,
      //进度条的进度，
      uploadStatusPhase2: 'warning',
    }
  },
  methods: {
    data2str(data) {
      return JSON.stringify(data);
    },

    Fn(method) {
      this[`${method}`]
    },

    loadSummary() {
      this.isLoaded = false;
      this.$http.get("/apisocial22/record/?summary=1&email=" + this.user.email,
          {headers: {"Authorization": "Token " + localStorage.token, 'content-type': 'multipart/form-data'}})
          .then(response => {
            console.log(response.data);
            this.summary = response.data;
            this.isLoaded = true;
          })
    },

    loadSummary2() {
      this.isLoaded2 = false;
      this.$http.get("/apisocial22/record2/?summary=1&email=" + this.user.email,
          {headers: {"Authorization": "Token " + localStorage.token, 'content-type': 'multipart/form-data'}})
          .then(response => {
            console.log(response.data);
            this.summary2 = response.data;
            this.isLoaded2 = true;
          })
    },

    loadUser() {
      this.$http.get("/apisocial22/people/?email=" + this.user.email,
          {headers: {"Authorization": "Token " + localStorage.token, 'content-type': 'multipart/form-data'}})
          .then(response => {
            this.user.uni_org = response.data.uni_org;
            this.user.team_name = response.data.team_name;
          })
    },

    loadFeedback() {
      this.$http.get("/apisocial22/feedback/?email=" + this.user.email,
          {headers: {"Authorization": "Token " + localStorage.token, 'content-type': 'multipart/form-data'}})
          .then(response => {
            this.isLoaded3 = true;
            this.feedbacks = response.data;
          })
    },

    saveChanges() {
      let formData = new FormData();
      formData.append('email', this.user.email);
      formData.append('uni_org', this.user.uni_org);
      formData.append('team_name', this.user.team_name);
      this.$http.put("/apisocial22/people/", formData,
          {headers: {"Authorization": "Token " + localStorage.token, 'content-type': 'multipart/form-data'}})
          .then(response => {
            if (response.data.status == 'success') {
              console.log('successfully change profile')
            }
          })
    },

    handleChange() {

    },

    uploadFile0(file, fileList) {
      console.log('sth')
      this.file = file;
      this.fileList[0] = fileList;
      this.submit(file, 0);
    },
    uploadFile1(file, fileList) {
      this.file = file;
      this.fileList[1] = fileList;
      this.submit(file, 1);
    },
    uploadFile2(file, fileList) {
      this.file = file;
      this.fileList[2] = fileList;
      this.submit(file, 2);
    },
    uploadFile3(file, fileList) {
      this.file = file;
      this.fileList[3] = fileList;
      this.submit(file, 3);
    },
    uploadFile4(file, fileList) {
      this.file = file;
      this.fileList[4] = fileList;
      this.submit(file, 4);
    },

    submit(file, task_index) {
      let formData = new FormData();
      formData.append('email', localStorage.email);
      formData.append('task', task_index);
      for (var i = 0; i < this.fileList[task_index].length; i++) {
        formData.append('files[' + i + ']', file['raw']);
      }
      this.$http.post("/apisocial22/record/", formData,
          {headers: {"Authorization": "Token " + localStorage.token, 'content-type': 'multipart/form-data'}})
          .then(response => {
            console.log(response.data);
            if (response.data.status == 'success') {
              this.current[task_index] = response.data.save_data;
              console.log(this.current);
              this.isUploaded[task_index] = true;
              console.log(this.isUploaded);
              this.loadSummary();
            }
          })
    },

    uploadFile02(file, fileList) {
      this.file = file;
      this.submit2(file, 0);
    },
    uploadFile12(file, fileList) {
      this.file = file;
      this.submit2(file, 1);
    },
    uploadFile22(file, fileList) {
      this.file = file;
      this.submit2(file, 2);
    },
    uploadFile32(file, fileList) {
      this.file = file;
      this.submit2(file, 3);
    },
    uploadFile42(file, fileList) {
      this.file = file;
      this.submit2(file, 4);
    },
    submit2(file, task_index) {
      this.isUploading2[task_index] = true;
      let formData = new FormData();
      formData.append('email', localStorage.email);
      formData.append('task', task_index);
      formData.append('status', 0);
      // for (var i = 0; i < this.fileList2[task_index].length; i++) {
      //   formData.append('files[' + i + ']', file['raw']);
      // }
      formData.append('file', file['raw']);
      let config = {
        headers: {"Authorization": "Token " + localStorage.token, 'content-type': 'multipart/form-data'},
        onUploadProgress: progressEvent => {
          this.uploadPercentPhase2 = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2));
        }
      }
      this.$http.post("/apisocial22/record2/", formData, config)
          .then(response => {
            console.log(response.data);
            this.isUploading2[task_index] = false;
            if (response.data.status == 'Uploaded') {
              this.loadSummary2();
            } else {
              this.isShowError = true;
            }

          })
    },
  },
  mounted() {
    this.user.email = localStorage.email;
    this.loadUser();
    this.loadSummary();
    this.loadSummary2();
    this.loadFeedback();
  },
  watch: {},
}
</script>

<style scoped>
.notice {
  color: grey;
  margin-top: -15px;
  margin-bottom: 20px;
  margin-left: 15px;
  font-weight: lighter;

}

</style>